module.exports = __webpack_public_path__ + "src/app/assets/images/sug-milano.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/sug-milano.png
// module id = 622
// module chunks = 0